import { Skeleton, Stack } from '@mui/material'
import React from 'react'

const LoadingInfos = () => {
  return (
    <Stack>
         <Skeleton variant="rounded"  height={400} />
    </Stack>
  )
}

export default LoadingInfos